import { ReactNode } from 'react';
import { Container } from '../../../Container';
import { Divider } from '../../../Divider';
import { Typography } from '../../../typography';

export interface OptionGroupProps {
    children?: ReactNode;
    label: ReactNode;
    groupId: string;
}

export const OptionGroup = ({ children, label, groupId }: OptionGroupProps) => (
    <Container role="group" id={groupId}>
        <Container data-container="separator" padding={['50', '0']} aria-hidden>
            <Divider />
        </Container>
        <Container padding={['100', '150', '0']}>
            <Typography variant="tertiary" textStyle="bodySmall" as="div" id={`${groupId}-label`}>
                {label}
            </Typography>
            {children}
        </Container>
    </Container>
);
